export default "__VITE_ASSET__CQ08I4sF__"